// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3FY0F","Success":"Button_Success__3k_dJ","Danger":"Button_Danger__2BDKt"};